import axiosInstance from '../api.service.js';
import constants from '../../constants/constants';

const ENDPOINTORIGIN = "JobTeamMember/";

const getJobTeamMembers = async (jobId) => await axiosInstance.get(ENDPOINTORIGIN + 'GetJobTeamMembers?jobId=' + jobId, constants.REQUIRE_INTERCEPTORS);

const changeFormLead = async (jobId, jobTeamMemberId) => await axiosInstance.get(ENDPOINTORIGIN + 'ChangeJobFormLead?jobId=' + jobId + '&jobTeamMemberId=' + jobTeamMemberId, constants.REQUIRE_INTERCEPTORS);

const getAvailableUsersForJob = async (jobId) => await axiosInstance.get(ENDPOINTORIGIN + 'GetAvailableUsersForJob?jobId=' + jobId, constants.REQUIRE_INTERCEPTORS);

const saveJobTeamMember = async (job) => await axiosInstance.post(ENDPOINTORIGIN + 'SaveJobTeamMember', job, constants.REQUIRE_INTERCEPTORS);

const deleteTeamMember = async (id) => await axiosInstance.get(ENDPOINTORIGIN + 'DeleteTeamMember?jobTeamMemberId=' + id, constants.REQUIRE_INTERCEPTORS);

export {
    getJobTeamMembers,
    changeFormLead,
    getAvailableUsersForJob,
    saveJobTeamMember,
    deleteTeamMember
}